// extracted by mini-css-extract-plugin
export default {"container":"PJRzVy5hLOaxK4D9CEfy","content":"N1ocLKlf9JLYN_FhOi6g","logoWrapper":"lSpTjlbo_UGEWUiPU6iF"};